module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/secondary_4-f278129cd699a6789c4cd9defdd8df99.png";